import React from "react"
import PropTypes from "prop-types"
import FormSectionAccordion from "../../../../../components/FormSectionAccordion"
import {Box} from "@mui/material"
import {garantiasFields} from "./constants"
import {renderGrid} from "../../../../../components/FieldRenderer"
import {verifyOcr} from "../../../utils/info-section-constants"

const GarantiasSection = ({
                              state,
                              ocr = false,
                              ocrState,
                              setSectionField,
                              isValid,
                              showError,
                              actions,
                              defaultOpen = false,
                              syncToken = 0
                          }) => (
    <FormSectionAccordion
        title="Garantias e LTV"
        isValid={isValid}
        showError={showError}
        actions={actions}
        defaultOpen={defaultOpen}
        syncToken={syncToken}
    >
        <Box sx={{mt: 1}}>
            {renderGrid(
                ocr ? verifyOcr(ocr, ocrState, garantiasFields) : garantiasFields,
                state,
                (key) => (value) => setSectionField("garantias", key, value),
                {},
                {},
                (key, value) => setSectionField("garantias", key, value)
            )}
        </Box>
    </FormSectionAccordion>
)

GarantiasSection.propTypes = {
    state: PropTypes.object.isRequired,
    ocr: PropTypes.bool,
    ocrState: PropTypes.object,
    setSectionField: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    showError: PropTypes.bool,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
}

export default GarantiasSection
